import React from 'react';
import { Section, Eyebrow, Lede, PrimaryLink } from './primitives';
import { LICENSING_EMAIL, LICENSING_MAILTO } from './contact';

// No form element, no state, no handler, no fetch. The mail client is the
// transport; the address is printed as selectable text for anyone whose
// browser has no mailto: handler registered.
const PROMPTS = [
  'Who your users are — internal desk, customers, community, treasury',
  "Where you'd deploy — AWS, GCP, Azure, on-prem, or undecided",
  'Roughly how many users you expect',
  'Your timeline, and any jurisdiction or compliance constraints',
];

export const ContactBlock = () => (
  <Section id="contact">
    <div className="rounded-xl border border-gray-700/60 bg-gray-800/40 p-8">
      <div className="grid gap-3.5">
        <Eyebrow>Contact us for details</Eyebrow>
        <h2 className="m-0 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
          Tell us what you&rsquo;re building.
        </h2>
        <Lede>
          Licensing terms, pricing, and deployment scope are handled case by case. Send us a few
          lines about your team and we&rsquo;ll come back with specifics — usually within two
          business days.
        </Lede>
      </div>

      <div className="my-7 flex flex-wrap items-center gap-x-5 gap-y-3">
        <PrimaryLink href={LICENSING_MAILTO}>Email us for details</PrimaryLink>
        <a
          href={`mailto:${LICENSING_EMAIL}`}
          className="select-text font-mono text-[0.95rem] text-cyan-400 hover:text-cyan-300"
        >
          {LICENSING_EMAIL}
        </a>
      </div>

      <div className="border-t border-gray-700/60 pt-5">
        <p className="mb-2.5 text-[0.92rem] text-gray-400">
          Including these makes the first reply a useful one:
        </p>
        <ul className="m-0 list-disc pl-5 text-[0.94rem] text-gray-400">
          {PROMPTS.map((p) => (
            <li key={p} className="my-1.5">
              {p}
            </li>
          ))}
        </ul>
      </div>

      <p className="mt-6 mb-0 text-[0.82rem] text-gray-500">
        Katbot is trading software, not financial advice, and does not manage funds on your behalf.
      </p>
    </div>
  </Section>
);

export default ContactBlock;
